'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { FeatherCalendar } from '@subframe/core';
import { Button, CampoDataBR, FilterChip } from '@/shared/components/ui';
import type { PeriodoPresetKey, PeriodoValor } from '@/shared/types/filtroPeriodo';
import { brParaIso, intervaloDoPreset, isoParaBr, PERIODO_PRESETS } from '@/shared/utils/periodoFiltro';
import { periodoCampoOptions } from '../utils/negociacoesFilterOptions';
import { PERIODO_NEGOCIACAO_VAZIO } from '../utils/negociacoesPeriodo';
interface PeriodoDrawerSectionProps {
  valor: PeriodoValor;
  onChange: (valor: PeriodoValor) => void;
}
export function PeriodoDrawerSection(t0) {
  const $ = _c(55);
  const {
    valor,
    onChange
  } = t0;
  let t1;
  if ($[0] !== valor.inicio) {
    t1 = () => isoParaBr(valor.inicio);
    $[0] = valor.inicio;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [inicioTexto, setInicioTexto] = useState(t1);
  let t2;
  if ($[2] !== valor.fim) {
    t2 = () => isoParaBr(valor.fim);
    $[2] = valor.fim;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [fimTexto, setFimTexto] = useState(t2);
  let t3;
  if ($[4] !== onChange || $[5] !== valor) {
    t3 = preset => {
      if (preset === "custom") {
        onChange({
          ...valor,
          preset
        });
        return;
      }
      const intervalo = intervaloDoPreset(preset);
      setInicioTexto(isoParaBr(intervalo.inicio));
      setFimTexto(isoParaBr(intervalo.fim));
      onChange({
        ...valor,
        ...intervalo,
        preset
      });
    };
    $[4] = onChange;
    $[5] = valor;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const selecionarAtalho = t3;
  let t4;
  if ($[7] !== onChange || $[8] !== valor) {
    t4 = (ponta, texto) => {
      if (ponta === "inicio") {
        setInicioTexto(texto);
      } else {
        setFimTexto(texto);
      }
      const iso = brParaIso(texto);
      if (iso || texto.trim() === "") {
        onChange({
          ...valor,
          [ponta]: iso,
          preset: "custom"
        });
      }
    };
    $[7] = onChange;
    $[8] = valor;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const digitar = t4;
  let t5;
  if ($[10] !== fimTexto || $[11] !== inicioTexto || $[12] !== valor) {
    t5 = ponta_0 => {
      const texto_0 = ponta_0 === "inicio" ? inicioTexto : fimTexto;
      if (texto_0.trim() === "" || brParaIso(texto_0)) {
        return;
      }
      const setTexto = ponta_0 === "inicio" ? setInicioTexto : setFimTexto;
      setTexto(isoParaBr(valor[ponta_0]));
    };
    $[10] = fimTexto;
    $[11] = inicioTexto;
    $[12] = valor;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const normalizarNoBlur = t5;
  let t6;
  if ($[14] !== onChange || $[15] !== valor.campo) {
    t6 = () => {
      setInicioTexto("");
      setFimTexto("");
      onChange({
        ...PERIODO_NEGOCIACAO_VAZIO,
        campo: valor.campo
      });
    };
    $[14] = onChange;
    $[15] = valor.campo;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const limpar = t6;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-2"><FeatherCalendar className="text-brand-600 h-4 w-4" /><span className="text-body-bold font-body-bold text-default-font">Período</span></div>;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = !valor.inicio;
  let t9;
  if ($[18] !== limpar || $[19] !== t8) {
    t9 = <div className="flex items-center justify-between">{t7}<Button variant="neutral-tertiary" size="small" onClick={limpar} disabled={t8}>Limpar</Button></div>;
    $[18] = limpar;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== onChange || $[22] !== valor) {
    t10 = periodoCampoOptions.map(campo => <FilterChip key={campo.key} active={valor.campo === campo.key} onClick={() => onChange({
      ...valor,
      campo: campo.key
    })}>{campo.label}</FilterChip>);
    $[21] = onChange;
    $[22] = valor;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10) {
    t11 = <div className="flex flex-wrap gap-2">{t10}</div>;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== selecionarAtalho || $[27] !== valor.preset) {
    t12 = PERIODO_PRESETS.map(preset_0 => <FilterChip key={preset_0.key} active={valor.preset === preset_0.key} onClick={() => selecionarAtalho(preset_0.key)}>{preset_0.label}</FilterChip>);
    $[26] = selecionarAtalho;
    $[27] = valor.preset;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12) {
    t13 = <div className="flex flex-wrap gap-2">{t12}</div>;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== digitar) {
    t14 = texto_1 => digitar("inicio", texto_1);
    $[31] = digitar;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== normalizarNoBlur) {
    t15 = () => normalizarNoBlur("inicio");
    $[33] = normalizarNoBlur;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== inicioTexto || $[36] !== t14 || $[37] !== t15) {
    t16 = <CampoDataBR label="De" texto={inicioTexto} onTextoChange={t14} onBlur={t15} />;
    $[35] = inicioTexto;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== digitar) {
    t17 = texto_2 => digitar("fim", texto_2);
    $[39] = digitar;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== normalizarNoBlur) {
    t18 = () => normalizarNoBlur("fim");
    $[41] = normalizarNoBlur;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== fimTexto || $[44] !== t17 || $[45] !== t18) {
    t19 = <CampoDataBR label={"At\xE9"} texto={fimTexto} onTextoChange={t17} onBlur={t18} />;
    $[43] = fimTexto;
    $[44] = t17;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t16 || $[48] !== t19) {
    t20 = <div className="flex items-center gap-3">{t16}{t19}</div>;
    $[47] = t16;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t11 || $[51] !== t13 || $[52] !== t20 || $[53] !== t9) {
    t21 = <div className="flex flex-col gap-3">{t9}{t11}{t13}{t20}</div>;
    $[50] = t11;
    $[51] = t13;
    $[52] = t20;
    $[53] = t9;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  return t21;
}